kimal.productDetail = {};
kimal.productDetail.$modal = $('#share-product-modal');
kimal.productDetail.$icon = $('.plus-btn--product-detail');
kimal.productDetail.$menuIcon = $('.product-detail__accordion__item--outer');
kimal.productDetail.$innerContent = $('.product-detail__accordion__content');
kimal.productDetail.gallery = {
  $container: $('#gallery-container'),
  $largeImg:  $('.product-carousel__item--large'),
  $thumbnail: $('.product-carousel__item--small'),
  $firstLargeImg: $('#large-carousel .product-carousel__item--large:first-of-type'),
  $firstSmallImg: $('#small-carousel .product-carousel__item--small:first-of-type'),
  $lastLargeImg: $('#large-carousel .product-carousel__item--large:last-of-type'),
  $lastSmallImg: $('#small-carousel .product-carousel__item--small:last-of-type')
},
kimal.productDetail.contactSection = $('#enquire-section');
kimal.productDetail.enquiryFormModes = {
    MODE_ENQUIRE:  'enquire',
    MODE_DOWNLOAD: 'download'
};
kimal.productDetail.updateForm = function(mode) {
  var $form = $('#gform_2'),
      navHeight = kimal.$mainNav.outerHeight();

  /*
  $.each(kimal.productDetail.enquiryFormModes, function(k, c) {
    $form.removeClass('mode--' + c);
  });
  $form.addClass('mode--' + mode);
  */

  var form_download = document.getElementById( 'mode--download' );
  var form_enquiry = document.getElementById( 'mode--enquire' );

  if ( mode === 'enquire' ) {
    form_download.style.display = "none";
    form_enquiry.style.display = "block";
  } else {
    form_download.style.display = "block";
    form_enquiry.style.display = "none";
  }

  // [BAREFACE] This should probably be done in the CSS and form settings
  // $form.find('input[name="input_6"]').val(mode[0].toUpperCase() + mode.substr(1));

  kimal.$pageElems.animate({
    scrollTop: (kimal.productDetail.contactSection.offset().top - navHeight)
 }, 500, 'easeOutQuart');
}

$('#close-modal-icon').on('click', function() {
  kimal.productDetail.$modal.fadeOut();
});

$('.product-detail__accordion__item--about .product-detail__accordion__header .plus-btn').addClass('minus');

//form functionality
$('#product-detail').on('click', '.cta--product-detail, .product-detail__accordion__header', function(e) {
  e.preventDefault();
  var $target = $(e.target);

  if($target.parents('.product-detail__accordion__header').length) {
      var li             = $target.parents('.product-detail__accordion__header'),
          plusBtn        = li.find('.plus-btn'),
          innerContent   = li.closest('.product-detail__accordion__item--outer').find('.product-detail__accordion__content'),
          height         = 0;

      kimal.productDetail.$innerContent.slideUp(400);

      if(!li.hasClass('active')) {
        kimal.productDetail.$icon.removeClass('minus');
        plusBtn.addClass('minus');

        innerContent.slideDown(400);

        kimal.productDetail.$menuIcon.removeClass('active');
        li.addClass('active');

      } else {
        plusBtn.removeClass('minus');
        li.removeClass('active');

        $('.product-detail__accordion__item--about .product-detail__accordion__header').removeClass('active');
        $('.product-detail__accordion__item--about .product-detail__accordion__header .plus-btn').removeClass('minus');
      }
  } else {
    switch ($target.attr('data-cta-type')) {
      case 'download':
        kimal.productDetail.updateForm(kimal.productDetail.enquiryFormModes.MODE_DOWNLOAD);
        break;
      case 'enquire':
        kimal.productDetail.updateForm(kimal.productDetail.enquiryFormModes.MODE_ENQUIRE);
        break;
      case 'share':
        kimal.productDetail.$modal.fadeIn();
        break;
    }
  }
});

//gallery
kimal.productDetail.gallery.$container.on('click', '.carousel-arrow, .product-carousel__item--small, #lightbox-trigger', function(e) {
  e.preventDefault();
  var $target         = $(e.target),
      direction       = $target.attr('data-direction'),
      activeLargeImg  = $('.product-carousel__item--large.active'),
      activeSmallImg  = $('.product-carousel__item--small.active'),
      prevImg         = activeLargeImg.prev(),
      nextImg         = activeLargeImg.next(),
      args            = [];

  switch (true) {
    case $target.is('.carousel-arrow'):
      if(direction === 'next') {
        nextImg.length > 0 ? args.push(nextImg, activeSmallImg.next()) : args.push(kimal.productDetail.gallery.$firstLargeImg, kimal.productDetail.gallery.$firstSmallImg);
      } else if(direction === 'prev') {
        prevImg.length > 0 ? args.push(prevImg, activeSmallImg.prev()) : args.push(kimal.productDetail.gallery.$lastLargeImg, kimal.productDetail.gallery.$lastSmallImg);
      }

      animate_gallery.apply(null, args);

      function animate_gallery(elem, thumb) {
        activeLargeImg.stop().fadeOut();
        elem.stop().fadeIn();
        elem.addClass('active');
        thumb.addClass('active');
        activeLargeImg.removeClass('active');
        activeSmallImg.removeClass('active');
        args = [];

        var $nextCaption = $('.product-carousel__captions__item[data-img-id="' + elem.attr('data-img-id') + '"]'),
            $thisCaption = $('.product-carousel__captions__item.active');

        var nextCaption = function() {
          if ($nextCaption.length) {
            $nextCaption.stop().fadeIn(function() {
              $nextCaption.addClass('active');
            });
          }
        };

        if ($thisCaption.length) {
          $thisCaption.stop().fadeOut(function() {
            $(this).removeClass('active');
            nextCaption();
          });
        } else {
          nextCaption();
        }
      }
      break;

    case $target.is('.product-carousel__item--small'):
      var $thumbnail      = $(this),
          imageId         = $thumbnail.attr('data-img-id'),
          $imgToload      = $('.product-carousel__item--large[data-img-id="' + imageId + '"]'),
          $smallImgToLoad = $('.product-carousel__item--small[data-img-id="' + imageId + '"]');

      kimal.productDetail.gallery.$largeImg.stop().fadeOut();
      $imgToload.stop().fadeIn();

      kimal.productDetail.gallery.$largeImg.removeClass('active');
      $imgToload.addClass('active')

      kimal.productDetail.gallery.$thumbnail.removeClass('active');
      $smallImgToLoad.addClass('active');
      break;

    case $target.is('#lightbox-trigger'):
      var $lightbox = $('#lightbox'),
          imgSrc    = $('.product-carousel__item--large.active').attr('data-img-src')

      $('#lightbox-img').attr('src', imgSrc);
      $lightbox.fadeIn();
      break;
  }
});

$('#close-lightbox-icon').on('click', function() {
  $('#lightbox').fadeOut();
});
